import { useMutation, useQuery } from "@tanstack/react-query";
import { useShallow } from "zustand/shallow";
import { useUIStore } from "../stores/ui-store";
import { UIState } from "../types/ui-types";
import { fetchCompany } from "../api/companies.api";

const useCompany = ({ companyId, enabled }) => {
  const [bearerToken] = useUIStore(
    useShallow((state: UIState) => [state.bearerToken])
  );

  // Fetch company data
  const {
    data: companyData,
    error: companyError,
    isLoading: isLoadingCompany,
    isSuccess: isCompanySuccess,
  } = useQuery({
    queryKey: ["companies", companyId],
    queryFn: () => fetchCompany(bearerToken, companyId),
    enabled: !!enabled,
  });

  return {
    company: companyData,
    companyError,
    isLoadingCompany,
    isCompanySuccess,
  };
};

export default useCompany;
